import { PulseProjectApi } from 'api/PulseProjectApi';
import { backendApiClient } from 'container/backendApiClient';

export const pulseProjectApi = new PulseProjectApi(backendApiClient);
